var render, staticRenderFns
import script from "./tagGroup.vue?vue&type=script&lang=js"
export * from "./tagGroup.vue?vue&type=script&lang=js"
import style0 from "./tagGroup.vue?vue&type=style&index=0&id=29ce8861&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ce8861",
  null
  
)

export default component.exports